import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en/translation.json';
import ko from './ko/translation.json';
import jp from './jp/translation.json';
import cnsi from './cn-si/translation.json';
import cntr from './cn-tr/translation.json';

import { convertLanguageJsonToObject } from './translations';

export const translationsJson = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
  jp: {
    translation: jp,
  },
  cnsi: {
    translation: cnsi,
  },
  cntr: {
    translation: cntr,
  },
};

// Create the 'translations' object to provide full intellisense support for the static json files.
convertLanguageJsonToObject(en);

export const i18n = i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: translationsJson,
    fallbackLng: 'en',
    debug:
      process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test',

    detection: {
      order: ['sessionStorage', 'navigator'],
      caches: ['sessionStorage'],
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
